import React from "react";
import { Glyphicon as GlyphiconRB } from "react-bootstrap";
import tooltip from "../../../MapStore2/web/client/components/misc/enhancers/tooltip";

const Glyphicon = tooltip(GlyphiconRB);
interface TooltipIconProps {
    id: string;
    glyph: string;
    className: string;
    tooltip: string;
}
const TooltipIcon = (props: TooltipIconProps) => {
    return props.tooltip ? (
        <div id={props.id} className={props.className}>
            <Glyphicon className={"text-primary"} glyph={props.glyph} tooltip={props.tooltip} />
        </div>
    ) : null;
};

export default TooltipIcon;
